import styled from 'styled-components'
// component
import { Scrollbar } from 'components/UI'
// themes
import { colors } from 'themes/index'

export const FiltersWrapper = styled(Scrollbar)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 16px;
  padding-top: 6px;

  > .MuiButtonBase-root {
    align-self: center;
    width: 48px;
  }
`

export const RuleWrapper = styled.div`
  align-items: center;
  border-radius: 4px;
  border: 1px solid gray;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  position: relative;
  cursor: pointer;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  }
`

export const FieldName = styled.span`
  font-weight: 600;
`

export const EntityLabel = styled.div`
  color: ${colors.white};
  font-weight: 600;
  margin-left: 4px;
  text-transform: uppercase;

  position: absolute;
  top: -6px;
  left: 0px;
  background: ${colors.purple400};
  border-radius: 2px;
  padding: 0 4px;
  font-size: 10px;
`

export const Value = styled.span`
  font-weight: bold;
`
